<template>
    <!-- Alerta de trial ou renovação -->
    <div>
        <b-modal
            id="stripeAlert"
            title="Alerta de Oportunidade!"
            hide-footer
            centered
        >
            <div>
                <p class="lh-lg">
                    Não perca mais tempo com correções manuais!
                    <br>

                    Assine agora mesmo a plataforma e-correção e transforme a sua forma de corrigir redações.

                    Aproveite nosso período de teste gratuito e descubra todos os benefícios que a e-correção pode
                    oferecer para otimizar a sua rotina como professor.

                    Não deixe essa oportunidade escapar! Assine hoje mesmo e eleve a qualidade da sua prática de
                    correção! 📝
                </p>

                <div class="d-flex w-100 mt-3 justify-content-center">
                    <a class="btn btn-success rounded-0" :href="information.endpoint_stripe">
                        Assine agora
                    </a>
                </div>
            </div>
        </b-modal>

        <div v-if="showAlert">
            <div class="alert rounded-0 mb-0 text-center" :class="information.ends_at ?  'alert-danger'  : 'alert-warning'" v-if="daysForEnd(7) && information.stripe_id">

                <span v-if="information.ends_at > information.trial_ends_at">
                    Sua assinatura
                    <span v-if="daysForEnd(5) < 0">está expirada</span>
                    <span v-if="daysForEnd(5) > 0 && daysForEnd(5) < 1 ">termina hoje</span>
                    <span v-if="daysForEnd(5) > 1">irá expirar em {{ Math.round(daysForEnd(5)) }} dia(s)</span>
                    <a :href="information.endpoint_stripe" v-if="information.ends_at" class="btn btn-sm ml-2 btn-primary">
                        {{ daysForEnd(5) < 0 ? 'Assinar agora' :'Renovar plano'  }}
                    </a>
                </span>
                <span class="d-flex flex-column flex-md-row justify-content-center alert align-items-center gap-2 mb-0 py-0" v-if="information.ends_at == null || information.ends_at === information.trial_ends_at">
                    <span v-if="daysForEnd(7) > 1 ">Seu teste acaba em {{ Math.round(daysForEnd(7)) }} dias</span>
                    <span v-if="daysForEnd(5) > 0 && daysForEnd(5) < 1 "> Seu teste termina hoje</span>
                    <span v-if="daysForEnd(5) < 0" >Seu periodo de teste acabou </span>
                    <div v-if="daysForEnd(7) > 1 " class="progress w-50 rounded-pill bg-white">
                        <div class="progress-bar" :class="'bg-'+ progress.color" role="progressbar" :style="'width:'+ progress.value + '%;' " :aria-valuenow="progress.value" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <a :href="information.endpoint_stripe" class="btn btn-sm btn-danger">Assinar agora</a>
                </span>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'information'
    ],
    computed: {
        showAlert() {
            return !! (
                this.information.is_owner
                && this.information.integration_stripe === 1
                && (this.information.trial_ends_at || this.information.ends_at)
            );
        },
        progress() {
            const value = ((7 - this.daysForEnd(7))/7).toFixed(2) * 100
            const color = value > 50 ? 'danger' : 'warning'

            return { value: value, color: color}


        }
    },
    created() {
        if (this.information.force_show && this.showAlert) {
            this.$nextTick(() => {
                this.$bvModal.show('stripeAlert')
            })
        }

    },
    methods: {

        daysForEnd(days) {
            const today = new Date()

            if (this.information.ends_at) {
                const endsAtDate = new Date(this.information.ends_at)
                const daysToEnd = (endsAtDate - today) / (1000 * 60 * 60 * 24)

                if (days >= daysToEnd) {
                    return daysToEnd
                }

                return false
            }

            const trialDate = new Date(this.information.trial_ends_at)
            const daysToEnd = (trialDate - today) / (1000 * 60 * 60 * 24)

            if (days >= daysToEnd) {
                return daysToEnd
            }

            return false
        }
    }
}
</script>

<style>

</style>
